import {
  useParams,
  usePathname,
  useRouter,
  useSearchParams,
} from "next/navigation";
import { useCallback } from "react";

export const useCustomRouter = () => {
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const searchParams = useSearchParams();

  const goBack = useCallback(
    async (fallbackUrl: string) => {
      if (window.history.state) {
        router.back();
      } else {
        router.push(fallbackUrl);
      }
    },
    [router]
  );

  return {
    ...router,
    pathname,
    params,
    searchParams,
    goBack,
  };
};
